import React, { forwardRef, PropsWithChildren } from "react";

interface Props {
	username: string;
}

// forwardRef is needed by react-flip-move to work with FCs
export const StudentTile = forwardRef<HTMLDivElement, PropsWithChildren<Props>>((props, ref) => (
	<div ref={ref} className="StudentTile" data-cy={`student-tile-${props.username}`} data-testid={`student-tile-${props.username}`}>
		{props.children}
	</div>
));
